import { TranslateLoader } from '@ngx-translate/core';

import { SharedTranslateLoader } from './shared-translate-loader';

export const createTranslateLoader = (): TranslateLoader => {
  return new SharedTranslateLoader();
};
